<template>
    <div class="section-divider">
        <span class="icon-text has-text-grey heading mb-0">
            <span v-if="icon" class="icon"><i :class="icon"></i></span>
            <span>{{ label }}</span>
        </span>
        <div class="section-line"></div>
    </div>
</template>

<script setup lang="ts">
    defineProps<{
        label: string;
        icon?: string;
    }>();
</script>

<style scoped>
    .section-divider {
        display: flex;
        align-items: center;
        gap: 0.75rem;
    }

    .section-line {
        flex: 1;
        height: 1px;
        background-color: var(--bulma-border);
    }
</style>
